<script>
  import { UsersRound } from 'lucide-svelte';
  
  export let iconClass = '';
</script>

<UsersRound class={iconClass} />